var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content",class:{'non-nav-bar': this.$store.state.isApp}})
}
var staticRenderFns = []

export { render, staticRenderFns }